import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import useSWR from "swr";
import { Search } from "lucide-react";
import { fetcher, money, swrOpts } from "@/lib/api";

export const SearchPanel = ({ onClose }) => {
  const [q, setQ] = useState("");
  const [debounced, setDebounced] = useState("");
  const nav = useNavigate();
  useEffect(() => {
    const t = setTimeout(() => setDebounced(q.trim()), 250);
    return () => clearTimeout(t);
  }, [q]);
  const { data } = useSWR(debounced.length > 1 ? `/products?q=${encodeURIComponent(debounced)}&limit=6` : null, fetcher, swrOpts);

  const submit = (e) => {
    e.preventDefault();
    if (q.trim()) nav(`/shop/?q=${encodeURIComponent(q.trim())}`);
  };

  return (
    <div className="border-t border-line bg-ink" onKeyDown={(e) => e.key === "Escape" && onClose()} data-testid="search-panel">
      <div className="container-x py-5">
        <form role="search" onSubmit={submit} className="relative">
          <label htmlFor="site-search" className="sr-only">Search products</label>
          <Search className="pointer-events-none absolute left-5 top-1/2 h-5 w-5 -translate-y-1/2 text-gray-500" aria-hidden />
          <input id="site-search" autoFocus value={q} onChange={(e) => setQ(e.target.value)} type="search" autoComplete="off"
            placeholder="Search by product, brand, strain or SKU"
            className="h-14 w-full rounded-full border border-line bg-panel pl-14 pr-32 text-base text-white placeholder:text-gray-500 focus:border-gold focus:outline-none"
            data-testid="search-input" />
          <button type="submit" className="btn-gold absolute right-1.5 top-1/2 min-h-[44px] -translate-y-1/2 px-5" data-testid="search-submit-button">Search</button>
        </form>
        {data?.items?.length > 0 && (
          <ul className="mt-3 divide-y divide-line overflow-hidden rounded-2xl border border-line bg-panel" data-testid="search-suggestions">
            {data.items.map((p) => (
              <li key={p.id}>
                <Link to={`/shop/product/${p.slug}/`} className="flex items-center gap-4 px-4 py-3 hover:bg-raised" data-testid={`search-suggestion-${p.slug}`}>
                  <img src={p.thumb} alt="" width="48" height="48" loading="lazy" className="h-12 w-12 rounded-lg bg-white object-contain p-1" />
                  <span className="flex-1 text-sm text-white">{p.name}<span className="block text-xs text-gray-500">{p.categories[0]?.name}{p.brand ? ` · ${p.brand}` : ""}</span></span>
                  <span className="text-sm font-semibold text-gold">{money(p.price)}</span>
                </Link>
              </li>
            ))}
            <li><button type="button" onClick={submit} className="w-full px-4 py-3 text-left text-sm font-semibold text-gold hover:bg-raised">See all {data.total} results →</button></li>
          </ul>
        )}
        {data && data.total === 0 && <p className="mt-3 px-2 text-sm text-gray-400">No products match “{debounced}”.</p>}
      </div>
    </div>
  );
};
